var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgHangup = function SvgHangup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 14.7c-1.4-1.8-5.9-2.9-13.3-3.3-7 0-11.4 1-13.2 3.1-.9 1.1-1.3 2.5-1.1 4.4 0 .4.2.8.5 1 .9.6 2.5.7 4.6.2 1.4-.3 2.2-.6 2.6-.9.4-.3.5-.9.4-1.4V17.2c0-.2 0-.3.1-.4 0-.2.1-.3.1-.5.1-.2.2-.3.3-.5.3-.3.6-.4 1-.4h8.7c.4 0 .7.1 1 .4.3.4.5 1 .3 1.5v1.5c.2.3.5.5.8.7.7.3 1.4.6 2.2.7 2.4.5 3.9.6 4.6.1.4-.3.7-.8.7-1.4.5-2 .3-3.4-.3-4.2z"
  })));
};
export default SvgHangup;